export default "__VITE_ASSET__DgVTV5Q7__"